import { Inject, Injectable } from '@angular/core';
import { LoiHttpClient } from 'loi-lti-common';
import { Observable } from 'rxjs';
import { CustomRequestOptions } from '../utils/custom-request-options';

@Injectable({
  providedIn: 'root'
})

export class RoleService {
  constructor(
    private httpClient: LoiHttpClient,
    @Inject('BASE_URL') private baseUrl: string,
    private requestOptions: CustomRequestOptions) { }

  getRole(): Observable<string> {
    console.log(`retreiving role`);
    return this.httpClient.get<string>(`${this.baseUrl}api/Role/Role`, this.requestOptions);
  }
}
